module.exports = __webpack_public_path__ + "assets/media/empty.776e783a.svg";